module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppScaffold', {
    attrs: {
      "grid": ""
    }
  }, [(_vm.ladder && !_vm.loading) ? _c('Card', [_c('h1', [_vm._v(_vm._s(_vm.$tradFor(_vm.ladder.terms.name)))]), _vm._v(" "), _c('nav', [_c('RoundedButton', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))]), _vm._v(" "), _c('RoundedButton', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.save))])], 1), _vm._v(" "), _c('div', {
    staticClass: "content2"
  }, [_c('aside', [_c('LadderPreview', {
    attrs: {
      "value": _vm.currentLadder
    }
  })], 1), _vm._v(" "), _c('section', [_c('label', [_vm._v("Ladder type")]), _vm._v(" "), _c('RadioGroup', {
    attrs: {
      "options": _vm.ladderTypeOptions
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.form.type = $$v
      },
      expression: "form.type"
    }
  }), _vm._v(" "), (_vm.isDoubleLadder) ? _c('label', [_vm._v("Horizontal spacing between pawls")]) : _vm._e(), _vm._v(" "), (_vm.isDoubleLadder) ? _c('NumberInput', {
    model: {
      value: (_vm.form.horizontalSpacingBetweenPawls),
      callback: function($$v) {
        _vm.form.horizontalSpacingBetweenPawls = $$v
      },
      expression: "form.horizontalSpacingBetweenPawls"
    }
  }) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Pawls count")]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.form.pawlsCount),
      callback: function($$v) {
        _vm.form.pawlsCount = $$v
      },
      expression: "form.pawlsCount"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Pawls interval")]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.form.pawlInterval),
      callback: function($$v) {
        _vm.form.pawlInterval = $$v
      },
      expression: "form.pawlInterval"
    }
  })], 1)])]) : _c('Card', [_c('Loader', {
    attrs: {
      "loading": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab439d30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/ladder-config.vue
// module id = 3341
// module chunks = 0